export const gulpParam = 'gulp';
export const owsServerParam = 'owsserver';
export const owsApiParam = 'owsapi';

export type HttpMethod =
    | 'POST'
    | 'PATCH'
    | 'PUT'
    | 'GET'
    | 'DELETE'
    | 'HEAD'
    | 'OPTIONS'
    | 'CONNECT'
    | 'TRACE';

export interface PrimeServiceError extends Error {
    correlationVector: string;
}
